import { useParams } from 'react-router-dom'
import { CheckoutButton, useApiQuery, useToast } from 'grabbitbot-legacy-ui'
import { paymentClient } from '../../api'

/** Equivalent of legacy `PlanListComponent` (audit §3/§6 — subscription plan
 * list + Stripe Checkout redirect). `:planId` opens that plan highlighted,
 * matching legacy's "open a specific plan's modal" route (a full modal
 * wasn't reproduced — the plan is scrolled-to/highlighted inline instead,
 * since `Modal` from the shared `ui` module adds no behaviour beyond that
 * here). */
export function PlanListPage() {
  const { planId } = useParams<{ planId?: string }>()
  const { data: plans, loading, error } = useApiQuery(() => paymentClient.listPlans(), [])
  const { showToast } = useToast()

  return (
    <div>
      <h1>Subscription plans</h1>
      {loading && <p>Loading plans…</p>}
      {error && <p role="alert">Could not load plans.</p>}
      {(plans ?? []).map((plan) => (
        <div key={plan.id ?? plan.name} className="screener-card" style={plan.id === planId ? { borderColor: 'var(--gbx-accent)' } : undefined}>
          <h2>{plan.name}</h2>
          {plan.price != null && (
            <p>
              {plan.price} {plan.currency ?? ''}/month
            </p>
          )}
          {plan.subscription?.status === 1 ? (
            <p>Active subscription.</p>
          ) : (
            plan.id && (
              <CheckoutButton
                payment={paymentClient}
                cause="plan-subscribe"
                target={{ kind: 'plan', ids: [plan.id] }}
                onError={(msg) => showToast(msg, 'error')}
              >
                Subscribe
              </CheckoutButton>
            )
          )}
        </div>
      ))}
    </div>
  )
}
